import React from "react";
import "./style.css";

export default function Loader() {
  return (
    <div className="loader-container">
      <div className="biz-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
